// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.good-modal {
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.good-modal .modal-content {
  background-color: white;
  border-radius: 30px;
  min-width: 300px;
  width: 700px;
}
.good-modal.true {
  display: grid;
  place-items: center;
  z-index: 100;
  background-color: rgba(100, 100, 100, 0.5);
}
.good-modal .submit {
  justify-content: space-around;
}
.good-modal .submit button {
  width: 200px;
  height: 40px;
  border-radius: 10px;
  box-shadow: 0px 4px 4px 0px rgba(58, 45, 71, 0.33);
  font-weight: bold;
}
.good-modal .submit button.save {
  background-color: rgb(165, 218, 99);
  color: white;
}
.good-modal .submit button.cancel {
  background-color: rgb(218, 120, 99);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/views/admin/journal/components/GoodModal/GoodModal.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AACF;AAAE;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAEJ;AAAE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,0CAAA;AAEJ;AAAE;EACE,6BAAA;AAEJ;AADI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kDAAA;EACA,iBAAA;AAGN;AAFM;EACE,mCAAA;EACA,YAAA;AAIR;AAFM;EACE,mCAAA;EACA,YAAA;AAIR","sourcesContent":[".good-modal {\r\n  display: none;\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  .modal-content {\r\n    background-color: white;\r\n    border-radius: 30px;\r\n    min-width: 300px;\r\n    width: 700px;\r\n  }\r\n  &.true {\r\n    display: grid;\r\n    place-items: center;\r\n    z-index: 100;\r\n    background-color: rgba(100, 100, 100, 0.5);\r\n  }\r\n  .submit {\r\n    justify-content: space-around;\r\n    button {\r\n      width: 200px;\r\n      height: 40px;\r\n      border-radius: 10px;\r\n      box-shadow: 0px 4px 4px 0px rgba(58, 45, 71, 0.33);\r\n      font-weight: bold;\r\n      &.save {\r\n        background-color: rgb(165, 218, 99);\r\n        color: white;\r\n      }\r\n      &.cancel {\r\n        background-color: rgb(218, 120, 99);\r\n        color: white;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
